<script>
  import Button from "$lib/components/Button.svelte";
  import PageSelector from "./PageSelector.svelte";
  import { clickOutside } from "$lib/utilities/dom-helpers";

  export let pageNums = [];
  export let onSelect;
  export let testid = null;
  export let arialLabel = null;

  let isOpen = false;
  function toggle() {
    isOpen = !isOpen;
  }
</script>

<div
  use:clickOutside={() => {
    isOpen = false;
  }}
>
  <PageSelector
    pageNum={"..."}
    on:click={toggle}
    {testid}
    {arialLabel}
    haspopup
    expanded={isOpen}
  />

  {#if isOpen}
    <ul class="absolute mt-8 bg-white drop-shadow-md flex flex-col max-h-[13.5rem] overflow-y-auto">
      {#each pageNums as pageNum}
        <Button
          variant="ghost"
          size="small"
          class="!ring-0 !rounded-0 !px-10"
          on:click={() => {
            toggle();
            onSelect(pageNum);
          }}
          arialLabel="Page {pageNum}"
        >
          {pageNum}
        </Button>
      {/each}
    </ul>
  {/if}
</div>
